/* eslint-disable default-case */
import produce from 'immer';

import {
  STATION_1,
  STATION_2,
  STATION_3,
  STATION_4,
  WARM_UP,
} from 'utils/constants/stations';
import {
  resetStations,
  resetVisitedStatusAllStations,
  setSelectedStation,
  setStations,
  setVideo,
  setVisitedStation,
  visitAllStations,
} from './actions';

const stationInitialState = {
  A: null,
  B: null,
  C: null,
};

const initialState = {
  loading: false,
  error: null,
  selectedStation: {
    station: null, // warmUp, station1, station2, ...
    group: null, // A, B, C
  },
  [WARM_UP]: null,
  [STATION_1]: stationInitialState,
  [STATION_2]: stationInitialState,
  [STATION_3]: stationInitialState,
  [STATION_4]: stationInitialState,
  visitedStations: [WARM_UP],
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case setVideo.TRIGGER:
      draft.loading = true;
      draft.error = null;
      break;
    case setVideo.SUCCESS:
      draft[WARM_UP] = payload[WARM_UP];
      draft[STATION_1] = payload[STATION_1];
      draft[STATION_2] = payload[STATION_2];
      draft[STATION_3] = payload[STATION_3];
      draft[STATION_4] = payload[STATION_4];
      break;
    case setVideo.FAILURE:
      draft.error = payload;
      break;
    case setVideo.FULFILL:
      draft.loading = false;
      break;

    case setStations.toString():
      draft[WARM_UP] = payload[WARM_UP];
      draft[STATION_1] = payload[STATION_1];
      draft[STATION_2] = payload[STATION_2];
      draft[STATION_3] = payload[STATION_3];
      draft[STATION_4] = payload[STATION_4];
      break;
    case resetStations.toString():
      draft[WARM_UP] = null;
      draft[STATION_1] = stationInitialState;
      draft[STATION_2] = stationInitialState;
      draft[STATION_3] = stationInitialState;
      draft[STATION_4] = stationInitialState;
      break;

    case setSelectedStation.toString():
      draft.selectedStation = payload;
      break;

    case setVisitedStation.toString():
      draft.visitedStations = [...new Set([...draft.visitedStations, payload])];
      break;
    case visitAllStations.toString():
      draft.visitedStations = [
        WARM_UP,
        STATION_1,
        STATION_2,
        STATION_3,
        STATION_4,
      ];
      break;
    case resetVisitedStatusAllStations.toString():
      draft.visitedStations = [WARM_UP];
      break;
    // no default
  }
}, initialState);

export default reducer;
